export default __webpack_public_path__ + "static/media/visa.86da8404.jpg";